import { FreddyTheme, freddyTheme, GridItem, GridItemProps } from '@coolblue-development/freddy';
import { ReactNode } from 'react';

type Props = {
  paddingTop?: boolean;
  paddingBottom?: boolean;
  padding?: { y?: keyof FreddyTheme['spacing']; x?: keyof FreddyTheme['spacing'] };
  children: ReactNode;
};

export const GridLayoutItem = ({
  paddingTop = true,
  paddingBottom = true,
  padding,
  children,
  ...gridItemProps
}: Props & GridItemProps) => {
  const xSpacing = padding?.x ? freddyTheme.spacing[padding.x] : freddyTheme.spacing[600];
  const ySpacing = padding?.y ? freddyTheme.spacing[padding.y] : freddyTheme.spacing[800];

  return (
    <GridItem
      {...gridItemProps}
      sx={{
        paddingTop: paddingTop ? ySpacing : '0',
        paddingBottom: paddingBottom ? ySpacing : '0',
        [freddyTheme.breakpoint.maxWidth('md')]: {
          paddingTop: paddingTop ? xSpacing : '0',
          paddingBottom: paddingBottom ? xSpacing : '0'
        },
        ...gridItemProps.sx
      }}
    >
      {children}
    </GridItem>
  );
};
